import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { fetchServicesRequested } from '@/features/services/servicesSlice';
import { ServiceCard } from '@/components/ServiceCard';
import { ValueProps } from '@/components/ValueProps';
import { WhyUs } from '@/components/WhyUs';
import styles from './Home.module.scss';

export const Home: React.FC = () => {
  const { t } = useTranslation('home');
  const dispatch = useAppDispatch();
  const { items, loading, error } = useAppSelector((state) => state.services);

  useEffect(() => {
    dispatch(fetchServicesRequested());
  }, [dispatch]);

  return (
    <main className={styles.main}>
      <section className={styles.hero}>
        <p className={styles.eyebrow}>{t('eyebrow')}</p>
        <h1 className={styles.title}>
          {t('titleLine1')}
          <br />
          {t('titleLine2')}
        </h1>
        <p className={styles.subtitle}>{t('subtitle')}</p>
      </section>

      <ValueProps />

      <WhyUs />

      <section id="services" className={styles.services}>
        {loading && <p className={styles.state}>{t('loading')}</p>}
        {error && <p className={styles.state}>{t('error')}</p>}
        {!loading && !error && (
          <div className={styles.grid}>
            {items.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
        )}
      </section>
    </main>
  );
};
